import cx from 'classnames';
import { Menu } from '@base-ui/react';
import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import { useReservationServiceContext } from '../state/ReservationServiceContext';
import styles from './EventFilterMenu.scss';
import { getEventOptions } from './utils';

const ALL_EVENTS_VALUE = 'all-events';

export const EventFilterMenu = () => {
  const { occupants, selectedEventId, setSelectedEventId } =
    useReservationServiceContext();
  const eventOptions = getEventOptions(occupants);
  const hasActiveFilter = selectedEventId !== null;

  const handleValueChange = (value: string) => {
    setSelectedEventId(value === ALL_EVENTS_VALUE ? null : value);
  };

  if (!eventOptions.length && !hasActiveFilter) {
    return null;
  }

  return (
    <Menu.Root>
      <Menu.Trigger
        aria-label="Filter by event"
        className={styles.filterButton}
      >
        {hasActiveFilter && (
          <span
            aria-label="Event filter applied"
            className={styles.filterStatusIndicator}
            role="status"
          />
        )}
        <Icon name="filter" />
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner
          className={styles.positioner}
          side="bottom"
          align="end"
          sideOffset={14}
        >
          <Menu.Popup className={styles.popup}>
            <Menu.Arrow className={styles.arrow}>
              <Icon name="arrowPopover" />
            </Menu.Arrow>
            <Menu.RadioGroup
              value={selectedEventId ?? ALL_EVENTS_VALUE}
              onValueChange={handleValueChange}
            >
              {[
                { id: ALL_EVENTS_VALUE, name: 'All events' },
                ...eventOptions,
              ].map(({ id, name }) => (
                <Menu.RadioItem
                  key={id}
                  value={id}
                  closeOnClick
                  className={cx(styles.menuItem, typography.h7_20)}
                >
                  <span className={styles.itemLabel}>{name}</span>
                  <Menu.RadioItemIndicator className={styles.indicator}>
                    <Icon name="smallCheck" />
                  </Menu.RadioItemIndicator>
                </Menu.RadioItem>
              ))}
            </Menu.RadioGroup>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
};
